import { useRef, useState, useEffect, useCallback, useContext } from 'react';
import './header.css';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import {
    CREATE_ORG_PATH,
    DASHBOARD_PATH,
    LOGIN_PATH,
    SETTINGS_PATH,
} from '../../router/RouteConstants';
import { API } from '../../services';
import { useIntl } from 'react-intl';
import userIcon from '../../assets/images/profilepic.png';
import { Context } from '../../context/Context';
import AIEduButton from '../../components/Button/AIEduButton';
import { useAuthenticate } from '../../hooks';

const Header = ({ isLoginPage = false }) => {
    const intl = useIntl();
    const { formatMessage: f } = intl;

    const toggleRef = useRef(null);
    const [toggleUser, setToggleUser] = useState(false);
    const [cookies, removeCookie] = useCookies('token');
    const navigate = useNavigate();
    const { accountInfo } = useAuthenticate();
    const { account } = accountInfo ?? {};
    const { userLogoUrl } = account ?? {};

    const { setSettingsCurrentActive, isSideMenuOpen, setIsSideMenuOpen } =
        useContext(Context);

    const clearCookies = () => {
        Object.keys(cookies).forEach((cookie) => {
            removeCookie(cookie, { path: '/' });
        });
        localStorage.setItem('logout', Date.now().toString());
        navigate(LOGIN_PATH, { replace: true });
    };

    const handleSignout = () => {
        API.signOut().then(() => {
            clearCookies();
        });
    };

    useEffect(() => {
        const toggleUserClick = (e) => {
            if (e.target.closest('.profile-card')) {
                return;
            }
            if (!toggleRef.current?.contains(e.target)) {
                setToggleUser(false);
            } else {
                setToggleUser(!toggleUser);
            }
        };
        document.addEventListener('click', toggleUserClick);
        return () => {
            document.removeEventListener('click', toggleUserClick);
        };
    }, [toggleUser]);

    const handleProfileTabClick = (tabIndex) => {
        navigate(SETTINGS_PATH);
        setToggleUser(!toggleUser);
        setSettingsCurrentActive(tabIndex);
    };

    const toggleSideMenu = () => {
        setIsSideMenuOpen(!isSideMenuOpen);
    };

    const ProfileCard = () => {
        return (
            <div className='profile-card'>
                <div className='profile-body'>
                    <div onClick={() => handleProfileTabClick(0)}>
                        Organization details
                    </div>
                    <div onClick={() => handleProfileTabClick(1)}>
                        Admin settings
                    </div>
                </div>
                <div className='profile-footer' onClick={handleSignout}>
                    Sign Out
                </div>
            </div>
        );
    };
    return (
        <header className='header'>
            {!isLoginPage && (
                <div className='hamburger-menu' onClick={toggleSideMenu}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            )}
            <div
                className='header-text'
                onClick={() => {
                    navigate(DASHBOARD_PATH);
                }}
            >
                {f({ id: 'AI_EDU_SAMSUNG_EDUCATION' })}
            </div>
            {window.location.pathname === CREATE_ORG_PATH && (
                <div className='right-side-items'>
                    <AIEduButton
                        className='btnPrimary'
                        label={f({ id: 'AI_EDU_SIGNOUT' })}
                        onClick={handleSignout}
                    />
                </div>
            )}
            {!isLoginPage && (
                <div className='right-side-items'>
                    <div className='icon'>
                        <div className='img-container'>
                            <img
                                src={userLogoUrl ? userLogoUrl : userIcon}
                                ref={toggleRef}
                            />
                        </div>
                        {toggleUser && <ProfileCard />}
                    </div>
                </div>
            )}
        </header>
    );
};

export default Header;
